import { gql } from "@apollo/client";

export const searchPages = gql`
  query SearchPages($query: String!) {
    pages {
      search(query: $query, isPublished: true) {
        results {
          id
          title
          description
          path
        }
      }
    }
  }
`;
